// extracted by mini-css-extract-plugin
export default {"mainGridHeaderText":"UserListPage_mainGridHeaderText__tu1-u"};